import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache, ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import errorLink from "./errorLink";
import { relayStylePagination } from "@apollo/client/utilities";



import usePersonAuthStore from "../../pages/store/personAuthStore";
import usePersonStore from "../../pages/store/personStore";
import { useEffect, useRef } from "react";

const loggerLink = new ApolloLink((operation, forward) => {
  console.log(`GraphQL Request:`, operation);
  operation.setContext({ start: new Date() });

  return forward(operation).map((response) => {
    const responseTime = Date.now() - operation.getContext().start;
    console.log(`GraphQL Response took: ${responseTime}`);
    return response;
  });
});
const authLink = setContext((_, { headers }) => {
  const token = usePersonAuthStore.getState().access_token;
  const company = usePersonStore.getState().company;

  return {
    headers: {
      ...headers,
      CompanyId: company?.id ?? null,
      LocationId: company?.defaultLocation?.id ?? null,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});
const httpLink = createHttpLink({
  uri: `${window.__env?.API_URL}/graphql/`,
});
function Apollo({ children }: any) {
  // const personAccessToken = usePersonAuthStore(state => state.access_token);
  const companyId = usePersonStore(state => state?.company?.id ?? null);
  const locationId = usePersonStore(state => state?.company?.defaultLocation?.id ?? null);

  const first = useRef(true);

  useEffect(() => {
    // skip the initial mount
    if (first.current) {
      first.current = false;
      return;
    }
    apolloClient.resetStore().catch(console.error);
  }, [companyId, locationId]);

  // const authLink = setContext((_, { headers }) => {
  //   // get the authentication token from local storage if it exists
  //   var authToken = personAccessToken;

  //   // return the headers to the context so httpLink can read them
  //   return {
  //     headers: {
  //       ...headers,
  //       'CompanyId': companyId,
  //       'LocationId': locationId,
  //       authorization: authToken ? `Bearer ${authToken}` : "",
  //     }
  //   }
  // });

  const links = ApolloLink.from([
    loggerLink,
    authLink,
    errorLink,
    httpLink
  ]);

  const apolloClient = new ApolloClient({
    link: links,
    connectToDevTools: true,
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            // students: relayStylePagination(),
            people: relayStylePagination(["role"]),
            persons: {
              keyArgs: ["query"],
              merge(existing, incoming) {
                return incoming;
              }
            },
            personStatsPerCompany: {
              keyArgs: ["query"],
              merge(existing, incoming) {
                return incoming;
              }
            }
          },
        },
        Location: {
          fields: {
            persons: {
              keyArgs: ["query"],
              merge(existing, incoming) {
                return incoming;
              }
            }
          }
        },
        Student: {
          fields: {
            persons: {
              keyArgs: ["query"],
              merge(existing, incoming) {
                return incoming;
              }
            },
          }
        },
        Person: {
          fields: {
            students: relayStylePagination(),
            locationStudents: relayStylePagination(),
          }
        }
      }
    })
  });

  return (
    <ApolloProvider client={apolloClient}>
      {children}
    </ApolloProvider>
  )
}

export default Apollo;
